var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { OnDestroy, OnInit, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { SidebarService, ModalService } from '@ibe/services/ui';
import { select, Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
// import { Passenger } from '@ibe.models/passenger.model.lib';
import * as fromStore from '../../../../store';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';
import * as OptionsBarActions from '@ibe/store/actions/options-bar.actions';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import * as Actions from '../../../../store/actions/user.actions';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import * as MilesBarActions from '@ibe/store/actions/miles-bar.actions';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import { INDRACustomerAccountService } from '@ibe.services/customer-account.indra.service';
import { INDRAMilesService } from '@ibe.services/miles.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import * as _ from 'lodash';
import { INDRA_CA_STATES_URL, INDRA_US_STATES_URL, INDRA_BR_STATES_URL, INDRA_AU_STATES_URL, INDRA_AR_STATES_URL, UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYWITHMILES_CHECKBOX, UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE, UPGRADE_ACCOUNT_SIDEBAR_SOURCE_SLIDER_AND_EXTRAS } from '@ibe.config';
var INDRAUpgradeMilesAndGoComponent = /** @class */ (function () {
    function INDRAUpgradeMilesAndGoComponent(_http, store, sidebar, customerAccountService, fb, modalService, ibeAdminService, sidebarService, milesService, storage) {
        var _this = this;
        this._http = _http;
        this.store = store;
        this.sidebar = sidebar;
        this.customerAccountService = customerAccountService;
        this.fb = fb;
        this.modalService = modalService;
        this.ibeAdminService = ibeAdminService;
        this.sidebarService = sidebarService;
        this.milesService = milesService;
        this.storage = storage;
        this.isAlive = true;
        this.triedToSubmit = false; // To know if we should show errors or not
        this.countryCodes$ = this.store.select(fromStore.getCountryCodes);
        this.infoLoaded = true;
        this.userInfo$ = this.store.pipe(select(fromStore.getUserInfo));
        this.userCountry = 'cenas';
        /*
        hasChanges: boolean = false;
        hasChanges$ = Observable.create(observer => {
            this.form.valueChanges.pipe(takeWhile(() => this.isAlive)).subscribe(values => {
                const changes = Object.keys(values).filter(key => values[key] != this.formOld[key]);
                observer.next(changes.length > 0);
            });
        });
        */
        this.confirmModalCallback$ = this.store.select(fromStore.getConfirmModalConfirm);
        this.confirmModalCallback = '';
        this.countriesWithStateValues = ['BR', 'CA', 'US', 'AU', 'AR'];
        this.stateCodes = [];
        this.stateCodesUS = [];
        this.stateCodesCA = [];
        this.stateCodesBR = [];
        this.stateCodesAU = [];
        this.stateCodesAR = [];
        this.stateOptions = Array();
        this.consentsToAdd = [];
        this.consentsToRevoke = [];
        this.showError = false;
        this.isLoading = false;
        // Initialize countryCodes variable
        this.getCountryCodes();
        this.INDRA_createForm();
        this.userInfo$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.userInfo = data;
                this.userCountry = data.country;
                this.form.statusChanges
                    .pipe(takeWhile(function () { return _this.isAlive; }))
                    .subscribe(function (status) {
                    if (status === 'VALID') {
                        _this.formOld = __assign({}, _this.form.value);
                    }
                });
                return [2 /*return*/];
            });
        }); });
        this.confirmModalCallback$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.confirmModalCallback = value;
            }
        });
        var sidebarItems = this.sidebarService.getSidebarParameters();
        if (sidebarItems !== null && sidebarItems.length > 0 && sidebarItems[0] !== null) {
            this.sidebarSource = sidebarItems[0].source;
        }
    }
    INDRAUpgradeMilesAndGoComponent.prototype.ngOnInit = function () {
        this.formOld = __assign({}, this.form.value);
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_createForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.form = this.fb.group({
                            cpf: [null],
                            nif: [null],
                            state: [null],
                            communication_milesego_email: [null],
                            communication_milesego_sms: [null],
                            treatment_consent: [null, Validators.required],
                            terms_conditions: [null, Validators.required],
                        });
                        return [4 /*yield*/, this._http.get(INDRA_US_STATES_URL).toPromise().then(function (data) {
                                _this.stateCodesUS = data;
                            }, function (err) {
                                console.error(err);
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._http.get(INDRA_BR_STATES_URL).toPromise().then(function (data) {
                                _this.stateCodesBR = data;
                            }, function (err) {
                                console.error(err);
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this._http.get(INDRA_AU_STATES_URL).toPromise().then(function (data) {
                                _this.stateCodesAU = data;
                            }, function (err) {
                                console.error(err);
                            })];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this._http.get(INDRA_AR_STATES_URL).toPromise().then(function (data) {
                                _this.stateCodesAR = data;
                            }, function (err) {
                                console.error(err);
                            })];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this._http.get(INDRA_CA_STATES_URL).toPromise().then(function (data) {
                                _this.stateCodesCA = data;
                            }, function (err) {
                                console.error(err);
                            })];
                    case 5:
                        _a.sent();
                        if (this.countriesWithStateValues.includes(this.userCountry)) {
                            this.form.controls['state'].setValidators(Validators.required);
                            switch (this.userCountry) {
                                case 'US':
                                    this.stateCodes = this.stateCodesUS;
                                    break;
                                case 'CA':
                                    this.stateCodes = this.stateCodesCA;
                                    break;
                                case 'BR':
                                    this.stateCodes = this.stateCodesBR;
                                    break;
                                case 'AU':
                                    this.stateCodes = this.stateCodesAU;
                                    break;
                                case 'AR':
                                    this.stateCodes = this.stateCodesAR;
                                    break;
                                default:
                                    break;
                            }
                            this.form.controls['state'].patchValue(null);
                            this.stateCodes.forEach(function (item) {
                                _this.stateOptions.push({
                                    text: item.state,
                                    value: item.code
                                });
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    INDRAUpgradeMilesAndGoComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_saveSidebar = function () {
        var _this = this;
        this.triedToSubmit = true;
        if (this.form.valid) {
            // this.formOld = { ... this.form.value };
            this.validateAllFormFields(this.form);
            this.triedToSubmit = false;
            var doctype = '';
            var docNumber = '';
            if (this.form.controls['cpf'].value) {
                doctype = '23';
                docNumber = this.form.controls['cpf'].value;
            }
            else if (this.form.controls['nif'].value) {
                doctype = '24';
                docNumber = this.form.controls['nif'].value;
            }
            this.INDRA_getConsents();
            var payload_1 = {
                'uniqueId': this.userInfo.airlineID ? this.userInfo.airlineID : '',
                'docType': doctype ? doctype : null,
                'docNumber': docNumber ? docNumber : null,
                'docIssueCountry': this.userCountry,
                'consentsListToAdd': this.consentsToAdd,
                'consentsListToRevoke': this.consentsToRevoke,
                'upgradeToMG': true
            };
            this.isLoading = true;
            this.customerAccountService.modifyCustomerAccount(payload_1).subscribe(function (res) {
                if (res && res.status === '200') {
                    _this.isLoading = false;
                    if (_this.sidebarSource === UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYWITHMILES_CHECKBOX) {
                        _this.store.dispatch(new OptionsBarActions.PutPriceUnit('miles'));
                        _this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(true));
                    }
                    // update user info on the store and session storage with the frequent flyer details
                    var userInfoBean = res.userProfileBean;
                    if (userInfoBean) {
                        var updatedUserInfo = _.cloneDeep(_this.userInfo);
                        updatedUserInfo['ffLevel'] = userInfoBean.ffLevel;
                        updatedUserInfo['ffCarrier'] = userInfoBean.ffCarrier;
                        updatedUserInfo['ffNumber'] = userInfoBean.ffNumber;
                        updatedUserInfo['currentPoints'] = userInfoBean.currentPoints;
                        _this.store.dispatch(new Actions.PutUserInfoAction(updatedUserInfo));
                        var userData = _.cloneDeep(_this.storage.get('userData'));
                        userData['ffLevel'] = userInfoBean.ffLevel;
                        userData['ffCarrier'] = userInfoBean.ffCarrier;
                        userData['ffNumber'] = userInfoBean.ffNumber;
                        userData['currentPoints'] = userInfoBean.currentPoints;
                        userData['userProfile']['ffLevel'] = userInfoBean.currentPoints;
                        userData['userProfile']['ffLevel'] = userInfoBean.ffLevel;
                        userData['userProfile']['ffCarrier'] = userInfoBean.ffCarrier;
                        userData['userProfile']['ffNumber'] = userInfoBean.ffNumber;
                        _this.storage.set('userData', userData);
                    }
                    _this.consentsToAdd = [];
                    _this.consentsToRevoke = [];
                    // this.TAP_closeSidebar();
                    _this.sidebar.closeSidebar();
                }
                else if (res.errors && res.errors.length > 0) {
                    _this.isLoading = false;
                    if (res.errors[0] && res.errors[0].desc) {
                        var error = res.errors[0].desc.split('-');
                        if (error && error.length > 0) {
                            if ((error[1] && error[1].trim() === 'CPF or NIF already exist. Update document if necessary.') || (error[2] && error[2].trim() === 'Invalid Fiscal ID')) {
                                if (payload_1.docType === '23') {
                                    _this.errorMessage = _this.INDRA_getTranslation('createAccountSidebar.upgrade.text.invalidCPFDesc');
                                }
                                else if (payload_1.docType === '24') {
                                    _this.errorMessage = _this.INDRA_getTranslation('createAccountSidebar.upgrade.text.invalidNIFDesc');
                                }
                            }
                            else {
                                _this.errorMessage = res.errors[0].desc;
                            }
                        }
                        else {
                            _this.errorMessage = res.errors[0].desc;
                        }
                        _this.showError = true;
                        _this.INDRA_scrollToError();
                    }
                    else {
                        _this.isLoading = false;
                        _this.errorMessage = _this.INDRA_getTranslation('createAccountSidebar.text.pleaseTryAgain');
                        _this.showError = true;
                        _this.INDRA_scrollToError();
                    }
                }
                else {
                    _this.isLoading = false;
                    _this.errorMessage = _this.INDRA_getTranslation('createAccountSidebar.text.pleaseTryAgain');
                    _this.showError = true;
                    _this.INDRA_scrollToError();
                }
                // this.closeSidebar();
            }, function (err) {
                if (err) {
                    _this.isLoading = false;
                    _this.showError = true;
                    _this.errorMessage = err;
                }
            });
        }
        else {
            this.INDRA_scrollToError();
        }
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_close = function (event) {
        if (event) {
            this.showError = false;
        }
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_getConsents = function () {
        this.consentsToAdd = [];
        this.consentsToRevoke = [];
        if (this.form.controls['terms_conditions'].value) {
            this.consentsToAdd.push('LOYTC', 'TAPPP');
        }
        else {
            this.consentsToRevoke.push('LOYTC', 'TAPPP');
        }
        if (this.form.controls['treatment_consent'].value === 'yes') {
            this.consentsToAdd.push('TAPPROF');
        }
        else {
            this.consentsToRevoke.push('TAPPROF');
        }
        if (this.form.controls['communication_milesego_email'].value) {
            this.consentsToAdd.push('LOYEMAIL');
        }
        else {
            this.consentsToRevoke.push('LOYEMAIL');
        }
        if (this.form.controls['communication_milesego_sms'].value) {
            this.consentsToAdd.push('LOYSMS');
        }
        else {
            this.consentsToRevoke.push('LOYSMS');
        }
    };
    INDRAUpgradeMilesAndGoComponent.prototype.validateAllFormFields = function (formGroup) {
        var _this = this;
        Object.keys(formGroup.controls).forEach(function (field) {
            var control = formGroup.get(field);
            if (control instanceof FormControl) {
                // control.markAsTouched({ onlySelf: true });
                control.markAsUntouched({ onlySelf: true });
            }
            else if (control instanceof FormGroup) {
                _this.validateAllFormFields(control);
            }
        });
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_scrollToError = function () {
        var sidebar = this.$sidebar.nativeElement;
        // const sidebarScrollPosition = sidebar.scrollTop;
        setTimeout(function () {
            sidebar.scrollTo({
                left: 0,
                top: 0,
                behavior: 'smooth'
            });
        }, 100);
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_closeSidebar = function () {
        var _this = this;
        if (this.sidebarSource === UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE) {
            this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslation('createAccountSidebar.upgrade.title.notCreateMilesGoAccount')));
            this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.loseDiscount') +
                this.INDRA_getTranslation('createAccountSidebar.upgrade.text.priceChange')));
            this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.createMilesGoAccount')));
            this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.continueWithoutDiscount')));
        }
        else if (this.sidebarSource === UPGRADE_ACCOUNT_SIDEBAR_SOURCE_SLIDER_AND_EXTRAS) {
            this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslation('createAccountSidebar.upgrade.title.cantPayFlightWithMiles')));
            this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.notPayFlightAndExtrasWithMiles')));
            this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.createMilesGoAccount')));
            this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.continueWithoutMGAccount')));
        }
        else {
            this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslation('createAccountSidebar.upgrade.title.cantPayFlightWithMiles')));
            this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.youChooseNotToUpgrade')));
            this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.backToPayingWithCash')));
            this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.upgradeToMilesGo')));
        }
        this.modalService.assignComponent(INDRAConfirmModalComponent);
        this.modalService.open();
        this.modalService.isOpen
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (!value) {
                if (_this.confirmModalCallback === 'ok') {
                    _this.store.dispatch(new ConfirmModalActions.ResetAction);
                }
                else {
                    if (_this.sidebarSource === UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE) {
                        _this.INDRA_removeMilesGoDiscount();
                    }
                    else {
                        _this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
                    }
                    _this.sidebar.closeSidebar();
                }
            }
        });
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_removeMilesGoDiscount = function () {
        this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction({ miles: 0, cash: 0 }));
        this.store.dispatch(new MilesBarActions.SetDiscount(0));
        this.store.dispatch(new BookedTripActions.PutBookedTripDiscountsAction([]));
        this.milesService.INDRA_updateMiles(0);
    };
    INDRAUpgradeMilesAndGoComponent.prototype.trackByFn = function (index, item) {
        return index; // or item.id
    };
    /**
     * Get list of countries with phone codes from file
     */
    INDRAUpgradeMilesAndGoComponent.prototype.getCountryCodes = function () {
        var _this = this;
        var URL = './assets/data/country_codes.json';
        var filePromise = this._http.get(URL).toPromise();
        filePromise.then(function (data) {
            _this.countryCodes = data;
        }, function (err) {
            console.error(err);
        });
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_hasErrors = function (control) {
        return control.invalid && this.triedToSubmit;
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_hasErrorsClasses = function (control, $event) {
        if ($event === void 0) { $event = null; }
        return this.INDRA_hasErrors(control) ? 'has-error' : '';
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_printPassengerTitle = function () {
        if (this.userInfo && this.userInfo.title) {
            return this.userInfo.title;
        }
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_printPhoneType = function () {
        var type = '';
        if (this.userInfo.contactPhone && this.userInfo.contactPhone.phoneType) {
            switch (this.userInfo.contactPhone.phoneType) {
                case '6':
                    type = this.INDRA_getTranslation('createAccountSidebar.text.home');
                    break;
                case '10':
                    type = this.INDRA_getTranslation('createAccountSidebar.text.mobile');
                    break;
                case '7':
                    type = this.INDRA_getTranslation('createAccountSidebar.text.business');
                    break;
            }
        }
        return type;
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_printPhoneNumber = function () {
        var _this = this;
        if (this.countryCodes && this.userInfo.contactPhone) {
            var FILTERED_COUNTRY_CODE = this.countryCodes.filter(function (country) {
                return country.code ===
                    _this.userInfo.contactPhone.countryCode;
            });
            if (FILTERED_COUNTRY_CODE.length === 1) {
                return (FILTERED_COUNTRY_CODE[0].dial_code +
                    ' ' +
                    this.userInfo.contactPhone.number);
            }
            return this.userInfo.contactPhone.number;
        }
        return;
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_Errors = function (control, field) {
        if (field === void 0) { field = null; }
        var errors = [];
        if (control.hasError('required')) {
            errors.push(field + " " + this.INDRA_getTranslation('createAccountSidebar.text.isRequired'));
        }
        if (control.hasError('email')) {
            errors.push(field + " " + this.INDRA_getTranslation('createAccountSidebar.text.isNotValid'));
        }
        if (control.hasError('MatchPassword')) {
            errors.push("" + this.INDRA_getTranslation('createAccountSidebar.text.passwordNotMatch'));
        }
        if (control.hasError('pattern') && field != 'Password') {
            errors.push(field + " " + this.INDRA_getTranslation('createAccountSidebar.text.isNotValid'));
        }
        if (control.hasError('pattern') && field == 'Password') {
            errors.push("" + this.INDRA_getTranslation('createAccountSidebar.text.mustContainAtLeast'));
        }
        return errors.join('; ');
    };
    INDRAUpgradeMilesAndGoComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    return INDRAUpgradeMilesAndGoComponent;
}());
export { INDRAUpgradeMilesAndGoComponent };
